export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Military-Grade Security',
      description: 'AES-256 encryption protects your data with the same level of security used by governments and financial institutions worldwide.'
    },
    {
      icon: 'ri-earth-line',
      title: 'Bypass Geo-Restrictions',
      description: 'Access your favorite content from anywhere in the world. Stream, browse, and download without geographical limitations.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Ultra-Fast Speeds',
      description: 'Optimized servers ensure minimal speed loss. Enjoy buffer-free streaming and lightning-fast downloads at all times.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Complete Privacy',
      description: 'Strict no-logs policy means your browsing history, connection times, and IP addresses are never recorded or stored.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously. Compatible with Windows, Mac, iOS, Android, and Linux operating systems.'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Our dedicated support team is available around the clock to assist you with any questions or technical issues.'
    },
    {
      icon: 'ri-wifi-line',
      title: 'Public WiFi Protection',
      description: 'Stay safe on public networks. Our VPN encrypts your connection, protecting you from hackers on unsecured WiFi hotspots.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Anonymous Browsing',
      description: 'Hide your IP address and location. Browse the internet anonymously without leaving any digital footprints behind.'
    }
  ];

  return (
    <section id="features" className="py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-8">
        <h2 className="text-5xl font-bold text-[#1A2B4A] text-center mb-6">
          Why Choose SERGAS VPN
        </h2>
        <p className="text-xl text-[#4A4A4A] text-center mb-20 max-w-3xl mx-auto">
          Experience the ultimate in online security and privacy with features designed to keep you protected
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-center"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#00A8E8] to-[#0088C8] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A2B4A] mb-4">{feature.title}</h3>
              <p className="text-[#4A4A4A] leading-relaxed text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-32 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A2B4A] via-[#2A3B5A] to-[#00A8E8]">
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <img
          src="https://public.readdy.ai/ai/img_res/4a9d75695eb6b3d22fe403f23111001e.jpg"
          alt="Secure Network"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-30"
        />

        <div className="relative z-10 max-w-7xl mx-auto px-8 py-24">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
            <div>
              <h2 className="text-6xl font-bold text-white mb-6 leading-tight">
                Start Browsing<br />Securely Today
              </h2>
              <p className="text-xl text-white/90 leading-relaxed">
                No logs. No limits.<br />Complete privacy.
              </p>
            </div>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group relative inline-flex items-center gap-4 bg-white text-[#1A2B4A] px-12 py-5 rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              Get Started Now
              <div className="flex items-center justify-center w-10 h-10 bg-[#1A2B4A] rounded-full">
                <i className="ri-arrow-right-line text-white text-xl"></i>
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
